module.exports = __webpack_public_path__ + "img/what-happens-desktop.e03b0726.webp";